export default `
fragment CharacterFragment on characters {
  id
  name
  biography
  slug
  state
  genderId: gender_id
  booksCount: books_count
  userId: user_id
  isLgbtq: is_lgbtq
  isPoc: is_poc
  hasDisability: has_disability
}
`;
